import axios from "axios";
import React, { FC, useEffect, useLayoutEffect, useState } from "react";
import { Setting, Subscription } from "../App";
import { CUSTOMER_API_URL } from "../constants";
import SubscriptionListDetail from "../components/SubscriptionListDetail";

export const SubscriptionList: FC<{ setting: Setting }> = ({ setting }) => {
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
  const [activeTab, setActiveTab] = useState<string>("tab-active");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const subscriptionsPerPage = 2;
  const handleTabChange = (newTabId: string) => {
    setActiveTab(newTabId);
    setCurrentPage(1);
    setTimeout(() => {
      resizeIframe();
    }, 300);
  };

  const resizeIframe = () => {
    const height = document.querySelector("body")!.scrollHeight;
    setting.resize(height);
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const activeSubscriptions = subscriptions.filter(
      (subscription) =>
          subscription.status === "ACTIVE" || subscription.status === "PAUSED"
  );

  const cancelledSubscriptions = subscriptions.filter(
      (subscription) => subscription.status === "CANCELLED"
  );

  const displayedSubscriptions =
      activeTab === "tab-active" ? activeSubscriptions : cancelledSubscriptions;

  const startIndex = (currentPage - 1) * subscriptionsPerPage;
  const endIndex = startIndex + subscriptionsPerPage;
  const visibleSubscriptions = displayedSubscriptions.slice(startIndex, endIndex);

  const totalPages = Math.ceil(displayedSubscriptions.length / subscriptionsPerPage);

  const MAX_VISIBLE_PAGES = 3;
  const visiblePages: any[] = [];

  if (totalPages <= MAX_VISIBLE_PAGES) {
    for (let page = 1; page <= totalPages; page++) {
      visiblePages.push(page);
    }
  } else {
    const middleIndex = Math.floor(MAX_VISIBLE_PAGES / 2);
    let startPage = Math.max(currentPage - middleIndex, 1);
    const endPage = Math.min(startPage + MAX_VISIBLE_PAGES - 1, totalPages);

    if (endPage - startPage < MAX_VISIBLE_PAGES - 1) {
      startPage = Math.max(endPage - MAX_VISIBLE_PAGES + 1, 1);
    }

    if (startPage > 1) {
      visiblePages.push(1);
    }

    if (startPage > 2) {
      visiblePages.push('...');
    }

    for (let page = startPage; page <= endPage; page++) {
      visiblePages.push(page);
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        visiblePages.push('...');
      }
      visiblePages.push(totalPages);
    }
  }

  useEffect(() => {
    axios
      .post(
        `${CUSTOMER_API_URL}?action=getSubscriptions`,
        {},
        { headers: { Authorization: setting.token } }
      )
      .then((response) => {
        setSubscriptions(response.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    const height = document.querySelector("body")!.scrollHeight + 100; // buffer;

    setting.resize(height);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptions]);

  return (
    <>
      <div className="shell">
        <div className="mp-subscription-page">
          <div className="mlh-title-global">SUBSCRIPTION<span>定期お届け便</span></div>
          <div className="mp-subscription-blocks">
            <div className="mlh-tab">
              <div className="mlh-tab-title col2">
                <button className={`tablinks ${activeTab === "tab-active" ? "active" : ""}`}
                        onClick={() => handleTabChange("tab-active")} id="tab-active">お申込み中</button>
                <button className={`tablinks ${activeTab === "tab-cancelled" ? "active" : ""}`}
                        onClick={() => handleTabChange("tab-cancelled")} id="tab-cancelled">解約済み</button>
              </div>

              <div id="mlh-apply" className="mlh-tabcontent active">
                {visibleSubscriptions.map((subscription, index) => (
                    <SubscriptionListDetail
                        setting={setting}
                        subscription={subscription}
                        index={index}
                        key={index}
                    />
                ))}

                {visibleSubscriptions.length === 0 && <p className="mlh-no-order">まだご注文はありません。</p>}
              </div>
            </div>
          </div>

          {visibleSubscriptions.length > 0 && <div className="mlh-pagenavi">
            <span className="mlh-page" onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}>«</span>
            {visiblePages.map((page, index) => (
                <span key={index} className={`mlh-page ${page === currentPage ? "active" : ""}`}
                      onClick={() => typeof page === "number" && handlePageChange(page)}>{page}</span>
            ))}
            <span className="mlh-page" onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages))}>»</span>
          </div>}
        </div>

        <div className="btn-mlh-bottom">
          <a 
            className="mlh-hover" 
            href={`${setting.referrer ? (setting.referrer.endsWith('/') ? setting.referrer : `${setting.referrer}/`) : '/'}account`}
            target="_parent" 
            title="マイページへ戻る"
          >
            マイページへ戻る
          </a>
        </div>
      </div>
    </>
  );
};
